var n=function(n,r){return null!=n&&r in Object(n)};export{n as _};
